// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"72712c59","57":"480b6527","156":"8fdb0e12","283":"bca682d1","429":"f5c0a587","619":"6ff38fa5","804":"a9883c80","884":"d3bd2cbc","939":"e30e6fd5","949":"9e9d3bb8"}[chunkId] + ".chunk.js";
};